// extracted by mini-css-extract-plugin
module.exports = {"artContainer":"style_artContainer__uUqZW"};